import Vue from 'vue'
import { FEEDBACK_ACCEPTED, FEEDBACK_REFUSED } from '../../../components/BidSessions/constants'

export default {
  setAdvertisingBidSessions (state, { bidSessions }) {
    state.advertising = bidSessions
  },

  deleteAdvertisingBidSession (state, { id }) {
    state.advertising = state.advertising.filter(bidSession => bidSession.id !== id)
  },

  setBiddingBidSessions (state, { bidSessions }) {
    state.bidding = bidSessions
  },

  deleteBiddingBidSession (state, { id }) {
    state.bidding = state.bidding.filter(bidSession => bidSession.id !== id)
  },

  setUnratedBidSessions (state, { bidSessions }) {
    state.unrated = bidSessions
  },

  removeUnratedBidSession (state, { id }) {
    state.unrated = state.unrated.filter(bidSession => bidSession.id !== id)
  },

  acceptOffer (state, { id, winnerBidcard, winnerBidder }) {
    let bidSession = state.advertising.find(bidSession => bidSession.id === id)
    if (bidSession) {
      Vue.set(bidSession, 'winnerBidcard', winnerBidcard)
      Vue.set(bidSession, 'winnerBidder', winnerBidder)
      Vue.set(bidSession, 'advertiserFeedback', FEEDBACK_ACCEPTED)
      Vue.set(bidSession, 'isSettled', true)
    }
  },

  refuseOffer (state, { id }) {
    let bidSession = state.advertising.find(bidSession => bidSession.id === id)
    if (bidSession) {
      Vue.set(bidSession, 'advertiserFeedback', FEEDBACK_REFUSED)
      Vue.set(bidSession, 'isSettled', true)
    }
  },

  reset (state) {
    state.advertising = []
    state.bidding = []
    state.unrated = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bid-sessions/mutations.js